import React from 'react';
import { companyInfo, aboutText } from '../data/mock';
import { getFileUrl } from '../utils/fileUtils';

const AboutSection = ({ settings }) => {
  const data = settings || companyInfo;

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src={getFileUrl(data.workshopImage) || companyInfo.workshopImage}
                alt="Taller Hallstatt"
                className="w-full h-[500px] object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/40 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-clay-primary/10 rounded-lg -z-10"></div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div>
              <h2 className="text-4xl sm:text-5xl font-bold text-stone-800 mb-4">
                {aboutText.title}
              </h2>
              <div className="h-1 w-24 bg-clay-primary mb-6"></div>
            </div>
            
            <p className="text-lg text-stone-700 leading-relaxed">
              {data.aboutText || aboutText.content}
            </p>

            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="space-y-2">
                <div className="text-4xl font-bold text-clay-primary">15+</div>
                <div className="text-stone-600 font-medium">Años de experiencia</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl font-bold text-clay-primary">100%</div>
                <div className="text-stone-600 font-medium">Fabricación local</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl font-bold text-clay-primary">500+</div>
                <div className="text-stone-600 font-medium">Máquinas vendidas</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl font-bold text-clay-primary">24/7</div>
                <div className="text-stone-600 font-medium">Soporte técnico</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default AboutSection;